import React, { useState, useEffect } from "react";
import ApiClient from "ApiClient";
import { toast } from "react-toastify";
import ErrorList from "Components/ErrorList";
import "react-toastify/dist/ReactToastify.css";

function handleSubmit(e) {
  e.preventDefault();
}

function AlgorithmForm() {
  toast.configure();
  const [availableAlgorithms, setAlgorithms] = useState([]);
  const [dataText, setDataText] = useState("");
  const [resultText, setResultText] = useState("");
  const [encryptionPassword, setEncryptionPassword] = useState("");
  const [selectedAlgorithm, setSelectedAlgorithm] = useState(null);

  useEffect(() => {
    ApiClient.get("/v1/GetAvailableAlgorithms")
      .then((res) => res.data)
      .then((data) => {
        setAlgorithms(data);
        setSelectedAlgorithm(data[0]);
      })
      .catch((error) => {
        toast.error(
          <div>
            <p>We could not communicate with the API right now. Please try again in a few seconds</p>
            <p>If the issue persists please contact the website Administrator</p>
          </div>
        );
      });
  }, []);

  function getResult(action) {
    toast.dismiss();
    if (dataText.length === 0 || selectedAlgorithm == null) return;
    setResultText("");

    const params = new URLSearchParams();
    params.append("algorithmId", selectedAlgorithm.id);
    params.append("action", action);
    params.append("data", dataText);
    if (selectedAlgorithm.type === 0) {
      params.append("password", encryptionPassword);
    }

    ApiClient.post("/v1/GetResult", params)
      .then((res) => setResultText(res.data))
      .catch((error) => {
        const newErrors = [];
        Object.values(error.response.data.errors).forEach((err) => (Array.isArray(err) ? err.forEach((val) => newErrors.push(val)) : newErrors.push(err)));
        toast.error(<ErrorList listClass="list-unstyled p-0 mb-1" errors={newErrors}></ErrorList>);
      });
  }

  function onAlgorithmChanged(e) {
    const algoId = e.target.options[e.target.selectedIndex].value;
    // eslint-disable-next-line eqeqeq
    const algo = availableAlgorithms.find((x) => x.id == algoId);

    setSelectedAlgorithm(algo);
    setEncryptionPassword("");
    setResultText("");
  }

  function getButtons() {
    if (selectedAlgorithm == null) return;

    const classVariables = "btn btn-primary mt-4 ps-3 pe-3 ms-2 me-2";

    switch (selectedAlgorithm.type) {
      case 0: // Encryption
        return (
          <div className="text-center">
            <button onClick={() => getResult("Encrypt")} className={classVariables} type="submit">
              Encrypt
            </button>
            <button onClick={() => getResult("Decrypt")} className={classVariables} type="submit">
              Decrypt
            </button>
          </div>
        );
      case 1: // Hash
        return (
          <div className="text-center">
            <button onClick={() => getResult("Hash")} className={classVariables} type="submit">
              Submit
            </button>
          </div>
        );
      case 2: // Encoding
        return (
          <div className="text-center">
            <button onClick={() => getResult("Encode")} className={classVariables} type="submit">
              Encode
            </button>
            <button onClick={() => getResult("Decode")} className={classVariables} type="submit">
              Decode
            </button>
          </div>
        );
      default:
        return null;
    }
  }

  return (
    <div className="pe-5 ps-5">
      <form onSubmit={handleSubmit}>
        <label className="font-weight-bold">Text to encrypt/encode</label>
        <textarea onChange={(e) => setDataText(e.target.value)} required placeholder="Enter the text would like to encrypt/encode" style={{ height: "200px" }} className="form-control"></textarea>
        <select onChange={onAlgorithmChanged} className="form-select mt-3 mb-3 w-auto ms-auto me-auto">
          {availableAlgorithms.map((item, i) => (
            <option key={i} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {selectedAlgorithm != null && selectedAlgorithm.type === 0 ? (
          <div>
            <label className="font-weight-bold">Password</label>
            <input onChange={(e) => setEncryptionPassword(e.target.value)} className="form-control mb-3"></input>
          </div>
        ) : null}
        <label className="font-weight-bold">Result</label>
        <textarea readOnly="readOnly" style={{ background: "white", height: "200px" }} className="form-control" value={resultText}></textarea>
        {getButtons()}
      </form>
    </div>
  );
}

export default AlgorithmForm;
